var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: {
                    type: "none",
                    name: "plantCd",
                    disabled: _vm.plantDisabled,
                  },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-process", {
                  attrs: { label: "공정", name: "processCd" },
                  model: {
                    value: _vm.searchParam.processCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "processCd", $$v)
                    },
                    expression: "searchParam.processCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "3단계위험성평가 목록",
            columns: _vm.gridRisk.columns,
            data: _vm.gridRisk.data,
            merge: _vm.gridRisk.merge,
            gridHeightAuto: "",
            selection: _vm.popupParam.type,
            rowKey: "ramThirdAssessScenarioId",
          },
          on: { rowDblclick: _vm.rowDblclick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "ramRiskLevelName"
                    ? [
                        _c(
                          "q-chip",
                          {
                            style: `background-color:${props.row.riskColor} !important;color:white;`,
                            attrs: {
                              "text-color": "white",
                              outline: "",
                              square: "",
                            },
                          },
                          [_vm._v(" " + _vm._s(props.row[col.name]) + " ")]
                        ),
                      ]
                    : col.name === "ramAfterRiskLevelName"
                    ? [
                        _c(
                          "q-chip",
                          {
                            style: `background-color:${props.row.riskColorAfter} !important;color:white;`,
                            attrs: {
                              "text-color": "white",
                              outline: "",
                              square: "",
                            },
                          },
                          [_vm._v(" " + _vm._s(props.row[col.name]) + " ")]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "검색", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _c("c-btn", {
                    attrs: { label: "선택", icon: "check", color: "orange" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }